#import "../fragments/AutomationListFields.graphql"

query AutomationsList(
  $status: AutomationStatus
  $search: String
  $page: Int
  $rowsPerPage: Int
) {
  automations(
    kind: BROADCAST
    status: $status
    search: $search
    page: $page
    rowsPerPage: $rowsPerPage
  ) {
    nodes {
      ...AutomationListFields
    }
    count
  }
}
